import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  MarketBanner,
  MarketEmptyState,
  MarketHeader,
  MarketList,
  MarketRow,
} from '@market/react';

import { Environment, sdk } from '@squareup/sq-addons-web-sdk';

import { CONTEXT } from 'local-host-data';

import LoadingScreen from 'screens/Loading';

import {
  contextErrorSelector,
  fetchContext,
  isFetchingContextSelector,
  posContextSelector,
} from 'store/context';

const SettingsSlot = () => {
  const dispatch = useDispatch();

  const posContext = useSelector(posContextSelector);
  const isFetchingContext = useSelector(isFetchingContextSelector);

  const contextError = useSelector(contextErrorSelector);

  const trainingMode = Boolean(posContext?.configurations?.trainingMode);

  const initializeSdk = useCallback(() => {
    dispatch(
      fetchContext(async () => {
        const sdkEnv = process.env.SQ_ADDONS_SDK_ENVIRONMENT as string;
        return await sdk.initialize(
          {},
          {
            environment:
              sdkEnv === 'LOCALHOST' ? Environment.LOCAL_HOST : Environment.POS,
            localHostData: {
              context: CONTEXT,
            },
          }
        );
      })
    );
  }, [dispatch]);

  useEffect(() => {
    initializeSdk();
  }, [initializeSdk]);

  if (isFetchingContext) {
    return <LoadingScreen />;
  }

  return (
    <div className="page-container">
      <div className="market-grid-container" data-testid="settings-screen">
        {contextError ? (
          <MarketEmptyState
            className="market-grid-item-full"
            data-testid="context-error-screen"
          >
            <h3 slot="primary-text">Unable to display settings</h3>
            <p slot="secondary-text">
              Please check your connection and try again.
            </p>
          </MarketEmptyState>
        ) : (
          <>
            <MarketHeader className="market-grid-item-full" compact>
              <h3>General</h3>
            </MarketHeader>
            <MarketBanner className="market-grid-item-full" variant="info">
              These settings can only be changed through your Square dashboard.
            </MarketBanner>
            <MarketList
              className="market-grid-item-full"
              style={{ marginTop: '16px' }}
            >
              <MarketRow data-testid="training-mode-configuration-row">
                <label slot="label">Training mode</label>
                <label slot="side-label">{trainingMode ? 'On' : 'Off'}</label>
              </MarketRow>
            </MarketList>
          </>
        )}
      </div>
    </div>
  );
};

export default SettingsSlot;
